import { createSlice } from "@reduxjs/toolkit";

export type ThemeKey = "light" | "dark";

export const normalizeThemeKey = (theme?: string | null): ThemeKey =>
  theme === "dark" ? "dark" : "light";

const getInitialTheme = (): ThemeKey =>
  normalizeThemeKey(
    typeof localStorage !== "undefined" ? localStorage.getItem("theme") : null
  );

const initialState = {
  theme: getInitialTheme(),
};

export const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setTheme: (state, action) => {
      state.theme = normalizeThemeKey(action.payload);
    },
    toggleTheme: (state) => {
      state.theme = state.theme === "dark" ? "light" : "dark";
    },
  },
});

export const { setTheme, toggleTheme } = themeSlice.actions;
export default themeSlice.reducer;
